/*
 *
 * PointsOfSales Actions
 *
 * @version 1.0.0
 * @author Serafino Busalacchi
 * @since 12-Mar-2026
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_FETCH_POINTS_OF_SALES: '@@PointsOfSales/fetch_points_of_sales',
  DO_FETCH_PRIVACY_POLICIES: '@@PointsOfSales/fetch_privacy_policies',
  DO_SET_SELECTED_POINT_OF_SALE: '@@PointsOfSales/set_selected_point_of_sale',
  DO_UPDATE_POINT_OF_SALE: '@@PointsOfSales/update_point_of_sale',
  DO_CREATE_OR_UPDATE_PRIVACY_POLICY: '@@PointsOfSales/create_or_update_privacy_policy',
  DO_DOWNLOAD_PRIVACY_POLICY_PDF: '@@PointsOfSales/download_privacy_policy_pdf',
  // @generator action:route:type
  ...createRequestTypes('@@PointsOfSales', 'CREATE_OR_UPDATE_PRIVACY_POLICY'),
  ...createRequestTypes('@@PointsOfSales', 'GET_POINTS_OF_SALES'),
  ...createRequestTypes('@@PointsOfSales', 'GET_PRIVACY_POLICIES'),
  ...createRequestTypes('@@PointsOfSales', 'UPDATE_POINT_OF_SALE'),
  ...createRequestTypes('@@PointsOfSales', 'RETRIVE_DOWNLOAD_PRIVACY_POLICY_PDF'),
// @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
* * Insert a description
* @name retriveDownloadPrivacyPolicyPdf
* @return {object} - The action object
*/
export const retriveDownloadPrivacyPolicyPdf = new MakeRequest('PointsOfSales', 'retrive_download_privacy_policy_pdf');
/** @action request
 * * Insert a description
 * @name getPointsOfSales
 * @return {object} - The action object
 */
export const getPointsOfSales = new MakeRequest('PointsOfSales', 'get_points_of_sales')
export const getPrivacyPolicies = new MakeRequest('PointsOfSales', 'get_privacy_policies')
export const createOrUpdatePrivacyPolicy = new MakeRequest('PointsOfSales', 'create_or_update_privacy_policy')
export const updatePointOfSale = new MakeRequest('PointsOfSales', 'update_point_of_sale')
// @generator action:route
/** @action
 * * Insert a description
 * @name DownloadPrivacyPolicyPdf
 * @return {object} - The payload object
 */
export const doDownloadPrivacyPolicyPdf = (payload) =>
  createAction(actionTypes.DO_DOWNLOAD_PRIVACY_POLICY_PDF, { payload })
/** @action
 * * Insert a description
 * @name CreateOrUpdatePrivacyPolicy
 * @return {object} - The payload object
 */
export const doCreateOrUpdatePrivacyPolicy = (payload, callback) =>
  createAction(actionTypes.DO_CREATE_OR_UPDATE_PRIVACY_POLICY, { payload, callback })
/** @action
 * * Insert a description
 * @name FetchPointsOfSales
 * @return {object} - The payload object
 */
export const doFetchPointsOfSales = (payload) => createAction(actionTypes.DO_FETCH_POINTS_OF_SALES, { payload })

export const doFetchPrivacyPolicies = (payload) => createAction(actionTypes.DO_FETCH_PRIVACY_POLICIES, { payload })

/** @action
 * * Insert a description
 * @name SetSelectedPointOfSale
 * @return {object} - The payload object
 */
export const doSetSelectedPointOfSale = (payload) =>
  createAction(actionTypes.DO_SET_SELECTED_POINT_OF_SALE, { payload })

/** @action
 * * Insert a description
 * @name UpdatePointOfSale
 * @return {object} - The payload object
 */
export const doUpdatePointOfSale = (payload, callback) =>
  createAction(actionTypes.DO_UPDATE_POINT_OF_SALE, { payload, callback })
